import { parseUtcDate } from '../../utils/dates'
/**
 * Map clinic-side event-type strings to human labels for the patient
 * portal practitioners surface. Backend stores raw event-type values
 * ("consultation", "therapy", "screening", "follow-up", etc.) — those
 * are not user-facing strings.
 */
const LABELS = {
  consultation: 'Consultation',
  'psychiatry-consultation': 'Psychiatry consult',
  'psychiatry-consult': 'Psychiatry consult',
  therapy: 'Therapy',
  psychotherapy: 'Therapy',
  screening: 'Screening',
  'follow-up': 'Follow-up',
  followup: 'Follow-up',
  'therapy-and-or-screening': 'Therapy / Screening',
  nutrition: 'Nutrition',
  'nutrition-consultation': 'Nutrition consult',
}

export function humaniseEventType(t) {
  if (!t) return 'Session'
  const key = String(t).toLowerCase().trim()
  if (LABELS[key]) return LABELS[key]
  return key
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')
}

export function humaniseSessionMode(m) {
  if (m === 'ONLINE') return 'Video call'
  if (m === 'OFFLINE') return 'In-clinic'
  return null
}

export function formatAppointmentTime(iso) {
  if (!iso) return null
  const d = parseUtcDate(iso)
  const sameDay = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  const now = new Date()
  const tomorrow = parseUtcDate(now.getTime() + 86400000)
  const datePart = sameDay(d, now)
    ? 'Today'
    : sameDay(d, tomorrow)
      ? 'Tomorrow'
      : d.toLocaleDateString([], { month: 'short', day: 'numeric', year: d.getFullYear() === now.getFullYear() ? undefined : 'numeric' })
  const timePart = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
  return `${datePart}, ${timePart}`
}
